export default __webpack_public_path__ + "static/media/019.de2ade2d.jpg";